module.exports = __webpack_public_path__ + "static/media/ic-send-cover.b5695194.svg";